import TopBar from "@/components/TopBar";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import ServicesSection from "@/components/ServicesSection";
import WhyChooseUs from "@/components/WhyChooseUs";
import ServiceAreas from "@/components/ServiceAreas";
import ReviewWidget from "@/components/ReviewWidget";
import FAQSection from "@/components/FAQSection";
import Footer from "@/components/Footer";
import Seo from "@/components/Seo";
import { faqs } from "@/lib/faq-data";

const Index = () => {
  const faqJsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  return (
    <div className="min-h-screen bg-background">
      <Seo
        title="Liz Luxes Cleaning | Orange Park & Jacksonville FL"
        description="Orange Park, FL cleaning company. Deep, residential, office, move in/out and Airbnb cleaning across Clay, Duval and St. Johns counties. Free estimates."
        path="/"
        jsonLd={faqJsonLd}
      />
      <TopBar />
      <Navbar />
      <main>
        <HeroSection />
        <ServicesSection />
        <WhyChooseUs />
        <ServiceAreas />
        <ReviewWidget />
        <FAQSection />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
